import { serializeCookie, setSerializedCookie } from 'utils/cookie';

const getKey = () => `gettingPassportInitiated`;

export const getGettingPassportInitiate = () => {
  try {
    const cookies = document.cookie;
    const cookieValue = cookies
      .split('; ')
      .find((row) => row.startsWith(`${getKey()}=`))
      ?.split('=')[1];
    return cookieValue ? JSON.parse(cookieValue) : null;
  } catch (e) {
    return null;
  }
};

export const setGettingPassportInitiate = () => {
  const serializedCookie = serializeCookie(getKey(), JSON.stringify(true), {
    path: '/',
    // Setting a reasonable expiration time (e.g., 24 hours)
    maxAge: 24 * 60 * 60,
  });
  setSerializedCookie(null, serializedCookie);
};

export const removeGettingPassportInitiate = () => {
  // Set an expired cookie to remove it
  const serializedCookie = serializeCookie(getKey(), '', {
    path: '/',
    maxAge: -1,
  });
  setSerializedCookie(null, serializedCookie);
};
